<app-mrp-scrolltop></app-mrp-scrolltop>
<!-- Heading -->
<div id="heading">

  <!-- <h1>Robert's Rules Bootcamp</h1>   -->
  <div class="banner-quote">
    "A diffusion of knowledge is the only guardian of true liberty."
    <p>-James Madison, 1825</p>
  </div>

  <!-- Video: only added after client hydration to avoid SSR loading issues -->
  @if (bannerVidVisible && isHydrated) {
  <video #floatingVideo class="floating-video" autoplay muted playsinline [src]="videoSrc"
    (loadeddata)="onVideoLoaded()" (error)="onVideoError($event)" (ended)="onVideoEnded()"
    (click)="toggleAudio(floatingVideo)" [attr.hidden]="(!videoLoaded && !attemptingPlay) ? true : null"
    [attr.aria-hidden]="!videoLoaded">
    <mat-icon>volume_up</mat-icon>
  </video>
  }

  <!-- Placeholder image for SSR/prerendering and shown until video actually loaded -->
  @if (bannerVidVisible && (!isHydrated || (!videoLoaded && !attemptingPlay))) {
  <picture>
    <!-- <source type="image/avif" srcset="assets/images/trainer-1200.avif 1200w, assets/images/trainer-800.avif 800w, assets/images/trainer-480.avif 480w" sizes="(min-width: 1200px) 1200px, 100vw"> -->
    <!-- <source type="image/webp" srcset="assets/images/trainer-1200.webp 1200w, assets/images/trainer-800.webp 800w, assets/images/trainer-480.webp 480w" sizes="(min-width: 1200px) 1200px, 100vw"> -->
    <img class="floating-video-placeholder" src="assets/images/trainer.png" alt="Robert's Rules Bootcamp Video"
      loading="lazy" width="120" height="120" (click)="onPlaceholderClick(true)">
  </picture>
  }

  <!-- No-JS fallback is handled by the server-rendered placeholder <img> above; removing <noscript> to avoid SSR hydration mismatch -->

</div>


<!-- Main -->
<main id="main" class="wrapper">
  <article class="inner">
    <div class="content">
      <h1 class="visually-hidden">Robert's Rules Bootcamp - Parliamentary Training</h1>
      <header>
        <h2>Get Answers, Get Trained</h2>
      </header>

      <p>Effectiveness begins with knowledge. Skill is acquired with practice. True participation in our government, or
        in leadership, requires both knowledge and skill. </p>

      <h4>Upcoming Dates</h4>
      @if (isLoading) {
      <div>
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
        <h5>Retrieving data...</h5>
      </div>
      }

      @if (!isLoading) {
      @if (products.length > 0) {
      <div>
        <div class="classlist-container">
          <table class="classes-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Date</th>
                <th>Purchase</th>
              </tr>
            </thead>
            <tbody>
              @for (product of products; track product) {
              <tr>
                <td (click)="gotoClass(product.item_CODE)">{{ product.productTitle }}</td>
                <td (click)="gotoClass(product.item_CODE)">{{ product.eventDate }}</td>
                <td>
                  <button class="purchase-btn" (click)="initiateCheckout(product.priceID, product.mode)"
                    [disabled]="isInitiating(product.priceID)">
                    @if (!isInitiating(product.priceID)) {
                    <span>{{ product.mode === 'subscription' ? 'Subscribe' : 'Register' }}</span>
                    }
                    @if (isInitiating(product.priceID)) {
                    <span class="checkout-spinner"></span>
                    }
                  </button>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      } @else {
      <div style="text-align: center; padding: 2rem;">
        <h4>No current Dates, check back soon...</h4>
      </div>
      }
      }

      <blockquote>"Meetings are much more productive."
        <p>- Lori, Saginaw County Chair
          <button class="interview-button" (click)="openVideoPlayer(0)" mat-icon-button aria-label="Open video player">
            <mat-icon class="interview-icon">videocam</mat-icon>
          </button>
        </p>
      </blockquote>

      <b></b>

      <p>To help you learn skill, and achieve effectiveness, we offer several methods to learn. This includes a <a
          routerLink="/bootcamp">Bootcamp</a> for the best learning experience, and evening <a
          routerLink="/zoom">Zoom</a> classes for convenience. See what others <a routerLink="/snippets">have to
          say.</a></p>

      <!-- <hr> -->

      <nav class="offering-container" aria-label="Main offerings">
        <h3 class="offering-header">Offerings</h3>

        <ul class="actions fit">
          <li><a routerLink="/zoom" class="button primary fit">Evening Zoom Classes</a></li>
        </ul>
        <ul class="actions fit">
          <li><a routerLink="/bootcamp" class="button primary fit">Saturday Bootcamps</a></li>
        </ul>
        <ul class="actions fit">
          <li><a routerLink="/adv-class" class="button primary fit">Advanced Zoom Class</a></li>
        </ul>
        <!-- <ul class="actions fit">
        <li><a routerLink="/snippets" class="button primary fit">Training Snippets</a></li>
      </ul> -->
        <ul class="actions fit">
          <li><a routerLink="/videotraining" class="button primary fit">Video/Audio Training</a></li>
        </ul>
        <ul class="actions fit ">
          <li><a routerLink="/tools" class="button primary fit">Free Tools/Guides</a></li>
        </ul>
        <ul class="actions fit ">
          <li><a routerLink="/questions" class="button primary fit">Common Meeting Questions</a></li>
        </ul>
        <ul class="actions fit ">
          <li><a routerLink="/michigangop" class="button primary fit">Michigan Delegates</a></li>
        </ul>
      </nav>
      <br>

      <p>The governance of our great country rests locally, on individuals, which is unique in all the world. Our
        founding fathers knew what it means to create an atmoshpere of knowledge, so that the entire group functions
        well together.</p>


      <p>The <a routerLink="/bootcamp">Bootcamps</a> offer the environment to practice Robert's Rules in a real
        scenarios. It will teach and improve your ability to pass or defeat resolutions. </p>
      <p><a routerLink="/zoom">Zoom</a> classes are designed to enhance knowledge and memorization. Memorization is a
        key component to being able to handle debate situations as they arise. </p>


      <h3>Learn Skill</h3>
      <p><a routerLink="/bootcamp">Skill</a> is the ability to do something well, to know what to do and when. Others
        recognize skill, and look to it. Skill comes first from knowledge, and then practice. Founding Father Samual
        Adams made the following statement, making it clear an individuals role in contributing to the betterment of
        society:</p>


      <blockquote>"If virtue and knowledge are diffused among the People, they will never be enslav'd. This will be
        their great Security."
        <p>-Samuel Adams February 12, 1779</p>
      </blockquote>



      <p><a routerLink="/zoom">Practice</a> is intentional process of performing an action correctly so that it becomes
        natural. Speaking is the process by which government is enacted. The better the speaker, the better the
        persuader, the better you will become at your job in governement, management and leadership.</p>

      <blockquote>"I have never had so much fun learning how to be effective." <p>- Lisa, 2023</p>
      </blockquote>
    </div>
  </article>
</main>

<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <!-- Elements -->
      <div class="row">
        <div class="col-12 col-12-medium">

          <!-- Lists -->
          <h3>RONR Topics</h3>
          <div class="row">
            <div class="col-12 col-12-small">
              <h4>Rights</h4>
              <ul>
                <li>Right to attend meetings</li>
                <li>Make motions</li>
                <li>Participate in debate</li>
                <li>Vote</li>
                <li>Make nominations</li>
                <li>Give advanced notice of motions</li>
              </ul>

              <blockquote>"Without liberty, law loses its nature and its name, and becomes oppression. Without law,
                liberty also loses its nature and its name, and becomes licentiousness."
                <p>-James Wilson 1790</p>
              </blockquote>
            </div>
            <div class="col-12 col-12-small">
              <h4>Parliamentary Topics</h4>
              <ol>
                <li>Motions for a body to take action</li>
                <li>Assignment, by which fair order of speaking is preserved</li>
                <li>Voting, by which decisions are made</li>
                <li>Debate, by which persuasion is performed</li>
                <li>Amendments, by which motions are customized</li>
                <li>Committees, by which research is performed</li>
                <li>Privileges, by which members have abilities</li>
                <li>Disciplinary Measures, by which a body can self-correct</li>
                <li>Reports, by which members are informed</li>
                <li>Conventions, by which members elect</li>
                <li>Quorum, by which integrity of the body is enabled</li>
              </ol>
            </div>
          </div>

          <h4>Definitions</h4>
          <dl>
            <dt>Parliamentary Law</dt>
            <dd>
              <p>"Parliamentary law originally was the name given to the rules and
                customs for carrying on business in the English Parliament that were
                developed through a continuing process of decisions and precedents
                somewhat like the growth of the common law. These rules and
                customs, as brought to America with the settling of the New World,
                became the basic substance from which the practice of legislative
                bodies in the United States evolved." -RONR 12th Ed, Preface pg xxix</p>
            </dd>
            <dt>Debate</dt>
            <dd>
              <p>"A formal discussion on a particular topic in a public meeting or legislative assembly, in which
                opposing arguments are put forward." -Oxford Dictionary</p>
            </dd>
            <dt>Voting</dt>
            <dd>
              <p><b>Putting the Question.</b> "When the debate appears to have
                closed, the chair may ask, “Are you ready for the question?” or
                “Is there any further debate?” If no one then rises to claim the
                floor, the chair proceeds to put the question—that is, he puts it
                to a vote after once more making clear the exact question the
                assembly is called upon to decide." - RONR 12th Ed 4:34</p>
            </dd>
          </dl>





          <!-- Blockquote -->
          <h3>Founding Fathers On The Key To Freedom</h3>
          <blockquote>
            "Freedom can exist only in the society of knowledge. Without learning, men are incapable of knowing their
            rights, and where learning is confined to a few people, liberty can be neither equal nor universal."
            <p>-Benjamin Rush, 1786</p>
          </blockquote>



        </div>

        <div class="col-12 col-12-medium">



          <h4>History &amp; Knowledge</h4>
          <p>
            <span class="image left"><img height="256" width="256" src="assets/images/lansing.png" alt=""></span>
            Robert's Rules lays out how meetings should be run, and discusses this process as "The kind of gathering in
            which parliamentary law is applicable is known as a deliberative assembly."
            This deliberative assembly is the key to what makes us American. It allows us to enact as a body after
            intelligently and fairly discussing amongst each other in the process known as debate. There is no other
            process which does this fairly, so that everyone feels the system is fair.
          </p>
          <p>
            <span class="image right"><img src="assets/images/rotunda.png" alt="" width="256" height="256"></span>
            While some may understand the mechanics of a motion, those rules encompass only a few pages of the book. The
            question is, How does one make a motion fairly in a large assembly? So that no one is cheated? No one is
            left unheard? That is the trick. That is the rest of the book. Human behaviour is complex, so it should be
            understood that rules are made to accommodate our complex natures.
          </p>

          <!-- Box -->
          <h3>Testimonials</h3>
          <div class="box">

            <blockquote>"I loved it! I enjoyed the role play too. I went in thinking I knew RR, but left much more
              educated." -Rhonda
            </blockquote>
            <blockquote>"Completely changed my attitude towards meetings. From dread to enthusiasm." -George
            </blockquote>
            <blockquote>"First time I have ever felt able to address the group. Thank you for helping me!." -Jean
            </blockquote>
            <blockquote>"The time was engaging. After eight hours of training, I felt empowered. Well spent day." -Bill
            </blockquote>
            <blockquote>"I enjoyed the training. I knew some about Robert's Rules, but plenty of role playing prepares
              you for the reality of needing to think quickly in various situations during meetings." -Mary
            </blockquote>
            <blockquote>"Very much enjoyed the training. I was familiar with RR as far as church business meetings go
              but learned much more at the training. I especially liked the quotes at the end…a reminder why we're
              working at this. Thank you!" -Val
            </blockquote>
            <blockquote>"Was very hesitant at first, but needed training. Afterwards I have a completely different view
              of RR. Looking forward to a meeting now." -John
            </blockquote>
            <blockquote>"Loved it!!!" -Annette
            </blockquote>
            <blockquote>"Thought I knew RR. Was very wrong. Thank you for a great day." -Mark
            </blockquote>
            <blockquote>"The training was great. I was familiar with RR, but JD really explained it so much more with
              the role playing." - Lisa
            </blockquote>
            <blockquote>"I felt like he gave me a good foundation on how RR work and why they were created. Excellent
              explanations and the role playing was helpful. I want to learn more!" -Bonnie
            </blockquote>
            <blockquote>"I also enjoyed the training and meeting with everyone. I really liked the cheat sheet page and
              plan on bringing that with me to next Republican meeting." -AnnMarie
            </blockquote>
            <blockquote>"I enjoyed the training also! I liked JD's style of working with the group and involving bible
              verses and roll playing to better understand how Roberts rules work." -Brenda
            </blockquote>
            <blockquote>"I cannot even begin to say how informative and fun JD's Robert's Rules training was! If you
              want to effectively take back your county you need to take this class. Although the class was 8 hours, the
              time flew. I wasn't ready to go at 8 hours. JD's teaching style draws and holds your attention the entire
              day. Well done." - Candace
            </blockquote>

          </div>



        </div>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>